import "./DataCollection.css";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import TextInput from "./Inputs/TextInput";
import LabeledBooleanInput from "./Inputs/LabeledBooleanInput";
import DateInput from "./Inputs/DateInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import { useTranslation } from "react-i18next";
import DropdownInput from "./Inputs/DropdownInput";
import { GENDERS } from "../Utils/PlanUtils";

const BCTESGDataCollection = ({ state }) => {
    const { t } = useTranslation();
    const beneficiary = state.beneficiary;
    const setBeneficiary = state.setBeneficiary;
    const application = state.application;
    const setApplication = state.setApplication;

    return (
        <form>
            <InputRowGroup label={t("BCTESG Grant")}>
                <InputRow label={t("Custodial Parent BC resident ID type")} presetValues={ //TODO figure out actual valid BC ID types
                    [
                        t("BC Services Card"),
                        t("BC Driver's License"),
                        t("BC Identification Card"),
                        t("BC Services Card"),
                        t("BC Driver's License"),
                        t("BC Identification Card")
                    ]
                } onPresetSelected={
                    (value) => {
                        setApplication({ ...application, bcResidentTypeOfID: value })
                    }
                }>
                    <TextInput state={application} name={"bcResidentTypeOfID"} onChange={handleChange(setApplication)} />
                </InputRow>
            </InputRowGroup>
        </form>
    );
};

export default BCTESGDataCollection;
